module.exports = __webpack_public_path__ + "static/media/gym_01.ecff63ba.png";